import { createAction, props } from '@ngrx/store';

const DASHBOARD_KEY = '[Dashboard]';

export const GetStaticData = createAction(
  `${DASHBOARD_KEY} get static data`,
  props<{ dataList: [] }>()
);

export const GetStaticDataSuccess = createAction(
  `${DASHBOARD_KEY} get static data success`,
  props<{ payload: any }>()
);

export const GetStaticDataFailure = createAction(
  `${DASHBOARD_KEY} get static data failure`
);

export const HmVacanciesLoading = createAction(
  `${DASHBOARD_KEY} hm vacancies is loading`,
  props<{ loading: boolean }>()
);

export const GetHmVacancies = createAction(
  `${DASHBOARD_KEY} get hm vacancies`,
  props<{ searchParams: any, toPush: boolean, chunckSize: number }>()
);

export const GetHmVacanciesSuccess = createAction(
  `${DASHBOARD_KEY} get hm vacancies success`,
  props<{ payload: any, toPush: boolean, loadMore: boolean }>()
);

export const ClearHmVacancies = createAction(
  `${DASHBOARD_KEY} clear hm vacancies`
);

export const SetVacancyStatus = createAction(
  `${DASHBOARD_KEY} set vacancy status`,
  props<{ id: string, status: string, jobBoards?: string[] }>()
);

export const SetVacancyStatusSuccess = createAction(
  `${DASHBOARD_KEY} set vacancy status success`,
  props<{ payload: any }>()
);

export const SetVacancyStatusFailure = createAction(
  `${DASHBOARD_KEY} set vacancy status failure`,
  props<{ error: any }>()
);

export const CloneVacancy = createAction(
  `${DASHBOARD_KEY} clone vacancy`,
  props<{ id: string }>()
);

export const CloneVacancySuccess = createAction(
  `${DASHBOARD_KEY} clone vacancy success`,
  props<{ id: string }>()
);

export const GetMatchById = createAction(
  `${DASHBOARD_KEY} get match by id`,
  props<{ id: string }>()
);

export const GetMatchByIdSuccess = createAction(
  `${DASHBOARD_KEY} get match by id success`,
  props<{ payload: any }>()
);

export const GetTalentById = createAction(
  `${DASHBOARD_KEY} get talent by id`,
  props<{ id: string; vacancyId?: string }>()
);

export const GetTalentByIdSuccess = createAction(
  `${DASHBOARD_KEY} get talent by id success`,
  props<{ payload: any }>()
);

export const DropTalentDetails = createAction(
  `${DASHBOARD_KEY} drop talent details`
);

export const GetVacancyById = createAction(
  `${DASHBOARD_KEY} get vacancy by id`,
  props<{ id: string }>()
);

export const GetVacancyByIdSuccess = createAction(
  `${DASHBOARD_KEY} get vacancy by id success`,
  props<{ payload: any }>()
);

export const DropVacancyDetails = createAction(
  `${DASHBOARD_KEY} drop vacancy details`
);

export const AlreadyLoaded = createAction(
  `${DASHBOARD_KEY} already loaded`
);

export const StartMatchCalculation = createAction(
  `${DASHBOARD_KEY} start match calculation`,
  props<{ vacancyId: any, skipApi: boolean }>()
);

export const EndMatchCalculation = createAction(
  `${DASHBOARD_KEY} end match calculation`
);

export const SetGlobalMatchCount = createAction(
  `${DASHBOARD_KEY} set global match count`,
  props<{ payload: null | { handledCount: number, totalCount: number } }>()
);

export const AdjustHardSoftSkills = createAction(
  `${DASHBOARD_KEY} adjust hard soft skills`,
  props<{ vacancyId: any, hardSkills: any[], softSkills: any[] }>()
);

export const AdjustHardSoftSkillsSuccess = createAction(
  `${DASHBOARD_KEY} adjust hard soft skills success`
);

